import PropTypes from "prop-types"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import GenericNotFound from "app/generic-not-found"
import { setExperiment } from "app-store-v2/app/actions"
import Homepage from "areas/homepage/jewlr"
import Landing from "areas/landing"

import fetchCollection from "./hoc/fetch-collection"
import useCollection from "./hoc/use-collection"
import FullLoading from "./loaders"

import Collection from "./"

const PROMISE_RINGS_COLLECTIONS = [
  "/promise-rings",
  "/promise-rings-collection",
  "/promise-rings-for-her",
  "/promise-rings-for-her-collection",
  "/mens-promise-rings",
  "/mens-promise-rings-collection",
]

const LoadCollection = ({ staticContext }) => {
  const { data, disabled, error } = useCollection()
  const { model, mountedPath } = data || {}
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.collection.loading)
  const vdayPromiseRingsExp = useSelector(
    (state) => state.experiment.vdayPromiseRings
  )

  useEffect(() => {
    if (
      vdayPromiseRingsExp &&
      PROMISE_RINGS_COLLECTIONS.includes(mountedPath)
    ) {
      dispatch(
        setExperiment({
          vdayPromiseRings: vdayPromiseRingsExp,
        })
      )
    }
  }, [mountedPath, dispatch, vdayPromiseRingsExp])

  if (error || disabled) {
    return <GenericNotFound staticContext={staticContext} />
  } else if (!data || loading === "full") {
    return <FullLoading />
  } else if (model === "landing") {
    return data.url_path === "homepage" ? <Homepage /> : <Landing />
  }

  return <Collection />
}

LoadCollection.propTypes = {
  staticContext: PropTypes.object,
}

export default fetchCollection(LoadCollection)
